<template>
<el-affix :offset="0">
    <div id="header">
        <div class="box">
            <div class="leftLogo" @click="to('/')"><img src="../assets/icon_logo.png" alt=""></div>
            <div class="tabUl">
                <el-menu
                    :default-active="activeIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    background-color="transparent"
                    text-color="#fff"
                    active-text-color="#FFFFFF"
                    @select="handleSelect"
                    :ellipsis = false
                >
                    <el-menu-item index="1" @click="to('/')">首页</el-menu-item>
                    <el-menu-item index="2" @click="to('/knowledge')">IPV6基础知识</el-menu-item>
                    <!-- <el-sub-menu index="2">
                        <template #title>IPV6基础知识</template>
                        <el-menu-item index="2-1" @click="to('/knowledge')">认识IPv6地址</el-menu-item>
                        <el-menu-item index="2-1" @click="to('/knowledge#address')">地址格式</el-menu-item>
                        <el-menu-item index="2-2" @click="to('/knowledge#headers')">报头结构</el-menu-item>
                        <el-menu-item index="2-3" @click="to('/knowledge#protocol')">协议特性</el-menu-item>
                        <el-menu-item index="2-4" @click="to('/knowledge#tool')">IPv6 工具</el-menu-item>
                        <el-menu-item index="2-5" @click="to('/knowledge#resources')">资源推荐</el-menu-item>
                    </el-sub-menu> -->
                    <el-menu-item index="3" @click="to('tutorialCenter')">教程中心</el-menu-item>
                    <el-menu-item index="4" @click="to('deploy')">部署与配置</el-menu-item>
                    <el-menu-item index="5" @click="to('case')">应用案例</el-menu-item>
                    <el-menu-item index="6" @click="to('download')">资源推荐</el-menu-item>
                    <!-- <el-sub-menu index="6">
                        <template #title>资源推荐</template>
                        <el-menu-item index="6-1" @click="to('/knowledge#resources')">资源推荐</el-menu-item>
                        <el-menu-item index="6-2" @click="to('download')">资源下载</el-menu-item>
                    </el-sub-menu> -->
                    <el-menu-item index="7" @click="to('case#search')">
                        <img
                            class="searchImg"
                            src="../assets/icon_search1.png"
                        />
                    </el-menu-item>
                </el-menu>
            </div>
        </div>
    </div>
    </el-affix>
</template>

<script>
export default {
    data(){
        return{
            activeIndex:'1',
        }
    },
    mounted () {
        this.setActiveIndex();
    },
    methods:{
        handleSelect(key,keypath){
        },
        to(name){
            this.$router.push(name);
        },
        setActiveIndex(){
            const activeList = ['/','','/tutorialCenter','/deploy','/case']
            this.activeIndex = activeList.indexOf(this.$route.path) + 1;
        }
    },
    watch:{
        $route(){
            this.setActiveIndex();
        }
    },

}
</script>

<style scoped lang="scss">
#header{
    width: 100%;
    height: 80px;
    background: linear-gradient( 180deg, #3D3D3D 0%, #242424 100%);
    color: #FFFFFF;
}
.box{
    height: 80px;
    margin:auto;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
}
.leftLogo{
    width:160px;
    height: 44px;
    float: left;
    margin-right: 40px;
}
.leftLogo img{
    width: 100%;
    height: 100%;
}
.tabUl{
    float: left;
    height: 100%;
    display: flex;
    align-items: center;
    ::v-deep .el-menu--horizontal{
        border: none;
        height: 100%;
    }
    ::v-deep .el-menu--horizontal>.el-menu-item{
        padding: 0 40px;
    }
    ::v-deep .el-menu--horizontal>.el-menu-item.is-active{
        border:none;
        position: relative;
        background: #000;
        &::before{
            content:'';
            width: 36px;
            height: 2px;
            background: #FFFFFF;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .searchImg{
        width: 20px;
        height: 20px;
    }
}
</style>
<style lang="scss">
.el-popper{
    margin-top: -6px!important;
}
.el-menu--popup{
    background: rgba(0,0,0,0.8)!important;
    min-width: 194px!important;
    max-width: 194px!important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    background-color: rgba(255,255,255,0.1)!important;
}
.el-popper.is-light{
    border: none!important;
    // background: linear-gradient(180deg, #3D3D3D 0%, #242424 100%)!important;
}
.el-menu--horizontal{
    border: none!important;
}
.el-popper{
    border-radius: 0!important;
}
</style>